import './AutosuggestionsPanel.scss';

import cn from 'classnames';
import React from 'react';

import {
  AutosuggestionsPanelDefaultProps,
  AutosuggestionsPanelPropTypes,
} from '@/ebat/components/blocks/ScanSelfService/SearchInput/AutosuggestionsPanel/AutosuggestionsPanel.proptypes';
import ProductTable from '@/ebat/components/blocks/ScanSelfService/SearchInput/AutosuggestionsPanel/ProductsTable/ProductTable';
import { useScanSelfServiceAutosuggestionsContext } from '@/ebat/contexts/ScanSelfServiceContext/ScanSelfServiceAutosuggestionsContext';

const AutosuggestionsPanel = ({ className, panelMaxHeight }) => {
  const { isOpen } = useScanSelfServiceAutosuggestionsContext();

  if (!isOpen) return null;

  return (
    <div
      className={cn(className, 'scan-self-service-autosuggestions-panel')}
      data-qa-id="autosuggestions-panel"
    >
      <ProductTable maxHeight={panelMaxHeight} />
    </div>
  );
};

AutosuggestionsPanel.defaultProps = {
  ...AutosuggestionsPanelDefaultProps,
};

AutosuggestionsPanel.propTypes = {
  ...AutosuggestionsPanelPropTypes,
};

export default AutosuggestionsPanel;
